import { useEffect, useRef, useState, createContext } from 'react'
import AddPainting from 'components/molecules/AddPainting/Index'
import ApiStatusIndicator from 'components/molecules/ApiStatusIndicator'
import { SortableList } from 'components/molecules/SortablePaintingTable'
import { usePainting } from 'providers/PaintingProvider'
import data from 'data/data.json'
import './styles.css'
import { useStatus } from 'providers/ApiStatusProvider'
import { Hero, Images, Painting } from 'models/painting'
import api from 'api'

const AdminForm = () => {
  const { setPainting, paintings, setPaintings } = usePainting()
  const { status } = useStatus()
  // use context to centralise this using a provider
  // do I want to make them a part of redux?

  const [oldVersion, setOldVersion] = useState(paintings)
  const [isEditing, setEditing] = useState(false)

  const editPainting = async painting => {
    setOldVersion(painting)
    setPainting(painting)
    setEditing(true)
  }

  const updateSortedPaintings = newPaintings => {
    api.sortPaintings(newPaintings, setPaintings)
  }

  return (
    <div className="container">
      <div className="form-container">
        <AddPainting
          oldVersion={oldVersion}
          isEditing={isEditing}
          setEditing={setEditing}
        />
      </div>
      <div className="table-container">
        <SortableList
          items={paintings}
          onChange={updateSortedPaintings}
          renderItem={item => (
            <SortableList.Item id={item.id}>
              <div>{item.name}</div>
              <button
                onClick={() => editPainting(item)}
                className="button muted-button"
              >
                Edit
              </button>
              <button
                onClick={() => api.deletePainting(item, setPainting)}
                className="button muted-button"
              >
                Delete
              </button>
              <SortableList.DragHandle />
            </SortableList.Item>
          )}
        />
      </div>
      {/* <ApiStatusIndicator apiStatus={status} />
      {isEditing ? <p>Editing Mode</p> : <p>Uploading Mode</p>} */}
    </div>
  )
}

export default AdminForm
